export default __webpack_public_path__ + "static/media/recordplayergif.23bcd828.gif";